import React, { Component } from 'react';
import AuthService from './AuthService';
import './Hvac.css';
import SetPointsPDF from '../pdf/SetPoints.pdf';
import ReactTooltip from 'react-tooltip';

import { find, isEqual } from 'lodash'

class Hvac extends Component {
    state = {
     data: []
    }

    constructor (props) {
      super(props);
      
    }
    
  // handleUserInput = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   this.props.onOptionsUpdate({
  //     [name]: parseInt(value)
  //   });
  // }

  handleUserInput = (e) => {
    let update ={}; //11-01-18
    if (e.target.value.length === 0) return false;
    const set = name => {
      const value = e.target.value;
      update[name] = parseInt(value)
    }
      const name = e.target.name;
      set(name) 
      //restrict user 11-01-18
      if(e.target.type === 'number') {
        const min = parseInt(e.target.getAttribute('min'));
        const max = parseInt(e.target.getAttribute('max'));
        const value = parseInt(e.target.value);
        console.log(min, max, value);
        
        if (value < min || value > max) return false;
      }  //end restrict 11-01-18
      this.props.onOptionsUpdate(update);
    }

  render() {
    return (

      <div>
        <div className="Hvac-Container">
          <div className="form-group">
            <label className="App-bold" htmlfor="occCool">Occupied Cooling Set Point:</label> &nbsp;
           <input type="number"
              name="occCool"
              min="0"
              max="90"
              step="1"
              value={this.props.options.occCool}
              onChange={this.handleUserInput}
              className="occ-cool-elem"
            /> &nbsp; <a data-tip="Enter the proposed occupied cooling set point" data-class='tool_tip' target="_blank" href={SetPointsPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
          </div>

          <div className="form-group">
            <label className="App-bold" htmlfor="occHeat">Occupied Heating Set Point:</label> &nbsp;
           <input type="number"
              name="occHeat"
              min="0"
              max="90"
              step="1"
              value={this.props.options.occHeat}
              onChange={this.handleUserInput}
              className="unocc-cool-elem"
            /> &nbsp; <a data-tip="Enter the proposed occupied heating set point" data-class='tool_tip' target="_blank" href={SetPointsPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
          </div>

          <div className="form-group">
            <label className="App-bold" htmlfor="unoccCool">Unoccupied Cooling Set Point:</label> &nbsp;
           <input type="number"
              name="unoccCool"
              min="0"
              max="90"
              step="1"
              value={this.props.options.unoccCool}
              onChange={this.handleUserInput}
              className="occ-heat-elem"
            /> &nbsp;&nbsp; <a data-tip="Enter the proposed unoccupied cooling set point" data-class='tool_tip' target="_blank" href={SetPointsPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
          </div>


          <div className="form-group">
            <label className="App-bold" htmlfor="unoccHeat">Unoccupied Heating Set Point:</label> &nbsp;
           <input type="number"
              name="unoccHeat"
              min="0"
              max="90"
              step="1"
              value={this.props.options.unoccHeat}
              onChange={this.handleUserInput}
              className="unocc-heat-elem"
            /> &nbsp;&nbsp; <a data-tip="Enter the proposed Unoccupied heating set point" data-class='tool_tip' target="_blank" href={SetPointsPDF}><i class="fas fa-question-circle green-icon"></i></a> 
            <ReactTooltip place="top" type="info" effect="solid" />
          </div>

        </div>
      </div>

    );
  }
}

export default Hvac;


// WEBPACK FOOTER //
// ./src/components/Hvac.js